/**
 * Роли (ТЗ 2.1) — те же коды, что в backend/src/core/authz/roles.ts.
 * Роль клиники привязана к паре «человек — клиника»; роли DODOC_* — глобальные.
 * Роли с обязательным вторым фактором задаёт окружение сервера (ADR-0019): клиент берёт их из GET /auth/policy
 * и из mfa.required ответа на вход, своего списка не держит.
 */
export const CLINIC_ROLES = ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'DOCTOR', 'FRONT_DESK', 'HR', 'ACCOUNTANT'] as const;
export type ClinicRole = (typeof CLINIC_ROLES)[number];

export const STAFF_ROLES = ['DODOC_SUPPORT', 'DODOC_MODERATOR', 'DODOC_QA', 'DODOC_ADMIN'] as const;
export type StaffRole = (typeof STAFF_ROLES)[number];

export type AppRole = ClinicRole | StaffRole;

export function isClinicRole(value: unknown): value is ClinicRole {
  return typeof value === 'string' && (CLINIC_ROLES as readonly string[]).includes(value);
}

export function isStaffRole(value: unknown): value is StaffRole {
  return typeof value === 'string' && (STAFF_ROLES as readonly string[]).includes(value);
}
